import React, { Component } from "react";
import { notification, message, Spin } from 'antd';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export default class RecPMes extends Component {

  state = {
    labels:[],
    values: [],
    loading: false
  }

  componentDidMount(){

    const { unidad_medica_user, periodo, backend } = this.props;

    fetch(`${backend}/recetasPMes/unidad/${unidad_medica_user}/periodo/${periodo}`,
      {
          method: "GET",
          headers: {
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          return res.json();
          
      }).then((data) => {
    
        let labels = [];
        let values = [];
        for (var i = 0; i < data.data.length; i++) {
            let row = data.data[i];
            labels.push(row.name);
            values.push(row.value);
        }
        
            this.setState({
                labels: labels,
                values: values,
                loading:true
            });
      }).catch((error) => {
          console.log(error);
          notification.error({
              message: 'Error',
              description: "Ocurrió un error al obtener las consultas por especialidad.",
          });
          message.destroy()
      });
  }

  render(){

    const { labels, values, loading } = this.state;

    const options = {
      responsive: true,
      plugins:[ChartDataLabels],
      plugins: {
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: 'Especialidades de la consulta',
          font:{
            size:'28'
          }
        },
        datalabels:{
          color: '#ffffff',
          font: {
            weight: 'bold',
            size: '15'
          }
        }
      },
    };
    
    const data = {
      labels,
      // labels: ['Medicina General', 'Medicina Interna', 'Ginecologia', 'Pediatria', 'Odocntologia', 'Nutricion', 'Psicologia'],
      datasets: [
        {
          // label: 'Dataset 1',      
          // data: [100, 500, 850, 360, 455, 789, 900],
          data: values,
          backgroundColor: [
            'rgba(52, 115, 194, 1)',
            'rgba(53, 179, 134, 1)',
            'rgba(248, 192, 2, 1)',
            'rgba(192, 15, 0, 1)',
            'rgba(131, 150, 175, 1)',
            'rgb(109, 81, 140, 1)',
            'rgb(197, 91, 15, 1)',
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(201, 203, 207, 0.2)'
          ],
        }
      ],
    };

    return(
      loading ? 
          <Bar 
          width={600}
          height={150}
          options={options} 
          data={data} 
          />
          :
          <Spin size="small"/>
    );
  }
}
